import { LineBufferState } from "./_types";

export const DEFAULT_STATE: LineBufferState = {
  fetching: false,
  error: false,
  filteredData: null,
}

export const DENSIFIERS_IDS = [1,2,3,4,5]